// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
var crashWith = function () {
    return $foreign["_crashWith"];
};
var crash = function () {
    return crashWith()("Partial.crash: partial function");
};
export {
    crash,
    crashWith
};
//# sourceMappingURL=index.js.map
